import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";

export default function PrkDialog() {
    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };


    return (
        <React.Fragment>
            <Button
                variant="contained"
                endIcon={<ArrowRightAltIcon />}
                onClick={handleClickOpen}
                sx={{
                    m: 1,
                    px: 2,
                    py: 0.9,
                    minHeight: 36,
                    borderRadius: "8px",
                    fontSize: "11px",
                    fontWeight: 600,
                    letterSpacing: "0.2px",
                    textTransform: "none",
                    backgroundColor: "#FFA726",
                    color: "#3E2723",
                    boxShadow: "0 2px 6px rgba(0, 0, 0, 0.12)",
                    transition: "all 0.2s ease",

                    "& .MuiButton-endIcon": {
                        marginLeft: "6px",
                        transition: "transform 0.2s ease",
                    },

                    "&:hover": {
                        backgroundColor: "#294e6b",
                        color: "#FFFFFF",
                        boxShadow: "0 4px 12px rgba(41, 78, 107, 0.3)",
                        transform: "translateY(-1px)",

                        "& .MuiButton-endIcon": {
                            transform: "translateX(3px)",
                        },
                    },

                    "&:active": {
                        transform: "translateY(0)",
                        boxShadow: "0 2px 5px rgba(0, 0, 0, 0.15)",
                    },
                }}
            >
                Informacje o poziomach PRK
            </Button>

            <Dialog
                fullWidth={true}
                maxWidth={true}
                open={open}
                onClose={handleClose}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                role="alertdialog"
            >
                {/* <DialogTitle id="alert-dialog-title">
                    POZIOMY PRK
                </DialogTitle> */}

                <DialogContent sx={{ padding: 0 }}>
                    <img
                        src="/poziomy PRK.png"
                        alt="Informacje o poziomach PRK"
                        style={{
                            display: 'block',
                            maxWidth: '100%',
                            height: 'auto',
                            margin: '0 auto',
                        }}
                    />
                </DialogContent>

                <DialogActions>
                    <Button onClick={handleClose} autoFocus>
                        Zamknij
                    </Button>
                </DialogActions>
            </Dialog>
        </React.Fragment>
    );
}